function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUprivate(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M7.102 16.832c.286.537.855.903 1.51.903a1.7 1.7 0 001.705-1.694 1.7 1.7 0 00-1.706-1.693c-.654 0-1.223.366-1.509.903H2a6.333 6.333 0 012.903-5.01 6.652 6.652 0 01-.036-.691c0-3.668 2.995-6.64 6.69-6.64 3.462 0 6.31 2.61 6.655 5.957C20.46 10.01 22 12.331 22 15.011c0 .08-.001.16-.004.24h-4.202a1.707 1.707 0 00-1.887-.861l-2.909-3.127a1.68 1.68 0 00.097-.564 1.7 1.7 0 00-1.706-1.693 1.7 1.7 0 00-1.706 1.693 1.7 1.7 0 001.706 1.694c.152 0 .3-.02.44-.057l2.869 3.083a1.678 1.678 0 00-.119.622 1.7 1.7 0 001.706 1.694c.655 0 1.223-.366 1.51-.903h3.96a6.944 6.944 0 01-6.704 5.077H8.387c-3.093 0-5.674-2.18-6.266-5.077h4.981z"
  }));
}

SvgUprivate.clsName = 'icon-www__uprivate';
SvgUprivate.remarkName = 'unknown';
export default SvgUprivate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uprivate.js
// module id = 2513
// module chunks = 17 18